import { render, staticRenderFns } from "./AccessWalletBitbox.vue?vue&type=template&id=73f8a2a0&scoped=true"
import script from "./AccessWalletBitbox.vue?vue&type=script&lang=js"
export * from "./AccessWalletBitbox.vue?vue&type=script&lang=js"
import style0 from "./AccessWalletBitbox.vue?vue&type=style&index=0&id=73f8a2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f8a2a0",
  null
  
)

export default component.exports